/** @format */

import {AccountsCompanyMediaplanType} from 'graphql/generated/types';

import {TanStackTableData} from 'components/Table/core/types';

import {safeDivide, roundFloatNumber} from 'helpers/numberHelpers';


import {CampaignStatFromQuery, KpiType, LastCheckType, SensorGroupsType} from '../types';
import {mapSensorGroups} from './mapSensorGroups';
import {mapSensorCount} from './mapSensorCount';
import {hasSensorGroups} from './hasSensorGroups';
import {calcKpiValue} from './calcKpiValue';

interface MapDataOptions {
  data: ReadonlyArray<CampaignStatFromQuery>;
  checks: ReadonlyArray<LastCheckType>;
  groups: SensorGroupsType;
  mediaplanType?: AccountsCompanyMediaplanType | null;
  primaryKpi?: KpiType;
  onRowClick?: (campaignId: string) => void;
}

const mapData = ({
  data,
  checks,
  groups,
  mediaplanType,
  primaryKpi,
  onRowClick,
}: MapDataOptions): TanStackTableData[] => {
  const showSensorGroups = hasSensorGroups(groups);

  return data
    .filter(stats => {
      if (!mediaplanType) return true;
      return stats.mediaplanType.toLowerCase() === mediaplanType.toLowerCase();
    })
    .map(stats => {
      // Вычисляем значения для каждой колонки

      // Сенсоры

      const checksInThisCampaign = checks.filter(check =>
        check.campaignIds.includes(stats.campaignId),
      );

      const sensors = showSensorGroups
        ? mapSensorGroups(checksInThisCampaign, groups, stats.campaignId)
        : mapSensorCount(checksInThisCampaign, stats.campaignId);

      // Присутствуют в данных таблицы всегда

      const ctrFloat = safeDivide(stats.clicks, stats.impressions) * 100;
      const ctr = roundFloatNumber(ctrFloat, 1);

      const spent = roundFloatNumber(stats.spent, 0);

      const resultData = {
        title: stats.campaignName,
        id: stats.campaignId,
        subAccount: stats.accountName,
        ...sensors,
        spent,
        impressions: calcKpiValue(stats, 'IMPRESSIONS'),
        clicks: calcKpiValue(stats, 'CLICKS'),
        ctr,
        cpc: calcKpiValue(stats, 'CPC'),
        cpm: calcKpiValue(stats, 'CPM'),
        onRowClick: onRowClick ? () => onRowClick(stats.campaignId) : undefined,
      } as TanStackTableData;

      // Присутствуют в данных таблицы только если являются основным KPI

      const primaryKpiId = primaryKpi?.name;

      if (primaryKpiId) {
        const kpiKey = primaryKpiId.toLowerCase();
        resultData[kpiKey] = calcKpiValue(stats, primaryKpiId);
      }

      return resultData;
    });
};

export {mapData};
